// Billing Summary filter persistence
export interface BillingSummaryFilters {
	startDate: string | null; // ISO
	endDate: string | null;   // ISO
	selectedProjects: string[]; // project names
	searchText: string;
}

export const initialBillingSummaryFilters: BillingSummaryFilters = {
	startDate: null,
	endDate: null,
	selectedProjects: [],
	searchText: ''
};
